/*
 * @Author: Teemo Ding
 * @Date: 2022-02-09 15:14:47
 * @LastEditTime: 2023-03-13 16:47:35
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/config.ts
 */
import {
  IFulfillmentStatus,
  ILogisticsMethod,
  IOrderStatus,
  IPaymentStatus,
} from '@/src/types/common/order';
import { getI18nFromGeneral } from 'src/tools/tools';

export const statusText = {
  [IOrderStatus.ACTIVE]: getI18nFromGeneral('general.status.active'),
  [IOrderStatus.SAVED]: getI18nFromGeneral('general.status.saved'),
  [IOrderStatus.DRAFT]: getI18nFromGeneral('general.status.draft'),
  [IOrderStatus.COMPLETED]: getI18nFromGeneral('general.status.completed'),
  [IOrderStatus.SUSPENDED]: getI18nFromGeneral('general.status.suspended'),
  [IOrderStatus.CANCELLED]: getI18nFromGeneral('general.status.cancelled'),
  [IOrderStatus.COMPLETE]: getI18nFromGeneral('general.status.completed'),
};

export const paymentStatusText = {
  [IPaymentStatus.PENDING]: getI18nFromGeneral('general.status.pendingPay'),
  [IPaymentStatus.FAILED]: getI18nFromGeneral('general.status.paymentFail'),
  [IPaymentStatus.PAID]: getI18nFromGeneral('general.status.paid'),
  [IPaymentStatus.PARTIAL_REFUNDED]: getI18nFromGeneral(
    'general.status.partiallyRefunded',
  ),
  [IPaymentStatus.REFUND_REQUESTED]: getI18nFromGeneral(
    'general.status.refundRequested',
  ),
  [IPaymentStatus.REFUND_APPROVED]: getI18nFromGeneral(
    'general.status.refundApprived',
  ),
  [IPaymentStatus.REFUNDED_REJECTED]: getI18nFromGeneral(
    'general.status.refundRejected',
  ),
  [IPaymentStatus.REFUND_ERROR]: getI18nFromGeneral(
    'general.status.refundError',
  ),
  [IPaymentStatus.RETURNING_IN_PROGRESS]: getI18nFromGeneral(
    'general.status.returnInProcess',
  ),
  [IPaymentStatus.RETURN_RECEIVED]: getI18nFromGeneral(
    'general.status.returnReceived',
  ),
  [IPaymentStatus.NONE]: getI18nFromGeneral('general.status.none'),
  [IPaymentStatus.REFUND_CONFIRMED]: getI18nFromGeneral(
    'general.paymentStatus.refundConfirmed',
  ),
  [IPaymentStatus.RETURN_DELIVERY_CONFIRMED]: getI18nFromGeneral(
    'general.status.returnDC',
  ),
  [IPaymentStatus.REFUNDED]: getI18nFromGeneral('general.status.refunded'),
  [IPaymentStatus.RETURN_CONFIRMED]: getI18nFromGeneral(
    'general.status.returnConfirmed',
  ),
  [IPaymentStatus.RETURN_REQUESTED]: getI18nFromGeneral(
    'general.status.returnRequested',
  ),
  [IPaymentStatus.RETURN_APPROVED]: getI18nFromGeneral(
    'general.status.returnApproved',
  ),
  [IPaymentStatus.RETURN_REJECTED]: getI18nFromGeneral(
    'general.status.returnRejected',
  ),
  [IPaymentStatus.RETURNED]: getI18nFromGeneral('general.status.returned'),
};

export const fulfillmentStatusesText = {
  [IFulfillmentStatus.OUT_OF_STOCK]: getI18nFromGeneral(
    'general.status.outofStock',
  ),
  [IFulfillmentStatus.READY_TO_PICK]: getI18nFromGeneral(
    'general.status.ready2Pick',
  ),
  [IFulfillmentStatus.READY_TO_PACK]: getI18nFromGeneral(
    'general.status.ready2Pack',
  ),
  [IFulfillmentStatus.READY_TO_SHIP]: getI18nFromGeneral(
    'general.status.ready2Ship',
  ),
  [ILogisticsMethod.Delivery]: getI18nFromGeneral(
    'general.status.readyToCollectCourier',
  ),
  [ILogisticsMethod.ClickCollect]: getI18nFromGeneral(
    'general.status.readyToCollectCustomer',
  ),
  [IFulfillmentStatus.NOTIFIED]: getI18nFromGeneral('general.status.notified'),
  [IFulfillmentStatus.COLLECTED]: getI18nFromGeneral(
    'general.status.collected',
  ),
  [IFulfillmentStatus.NONE]: getI18nFromGeneral('general.status.none'),
  [IFulfillmentStatus.DELIVERED]: getI18nFromGeneral(
    'general.status.delivered',
  ),
  [IFulfillmentStatus.READY_TO_COLLECT]: getI18nFromGeneral(
    'general.status.ready2Collect',
  ),
  [IFulfillmentStatus.DELIVERING]: getI18nFromGeneral(
    'general.status.delivering',
  ),
};
